import "./styles.less";
import usePropertyData from "src/hooks/propertyData/usePropertyData";

export function LocationTag({ hideAddress = false }) {
	const { listing } = usePropertyData();

	return (
		<span className="property-location-tag" >
			{(!hideAddress && listing.showAddress && listing.address && listing?.locations?.locality[0]) &&
				<p style={{ margin: '0' }} className="body body-1 body-regular medium">
					{listing?.locations?.locality[0]?.name}
					{listing?.locations?.state && `, ${listing?.locations?.state[0]?.name}`}
				</p>
			}
			<p className="body body-1 body-regular medium">
				{listing?.locations?.neighbourhood && listing?.locations?.neighbourhood[0]?.name}{listing?.locations?.state && `, ${listing?.locations?.state[0]?.name}`} </p>
		</span>
	);
}


